export const SET_COMPARE_ITEMS = 'compare:items:set';
export const ADD_COMPARE_ITEM = 'compare:items:add';
export const COMPARE_START_LOAD = 'compare:startLoad';
export const COMPARE_ERROR = 'compare:triggerError';
export const COMPARE_SET_ALERT = 'compare:alert:set';
